import { apiSlice } from './apiSlice';

export interface AgentContactSupportResponse {
  success: boolean;
  message: string;
  contacts: {
    global: {
      whatsapp: string | null;
      telegram: string | null;
      imo: string | null;
    };
    upline: {
      whatsapp: string | null;
      telegram: string | null;
      imo: string | null;
      firstname?: string | null;
      lastname?: string | null;
      profileImage?: string | null;
    };
  };
}

export const agentContactSupportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAgentContactSupport: builder.query<AgentContactSupportResponse, void>({
      query: () => ({
        url: '/contact-support/for-me',
        method: 'GET',
        requiresAuth: true,
      }),
    }),
  }),
});

export const { useGetAgentContactSupportQuery } = agentContactSupportApi;
